import React, { useState, useContext } from "react";
import { Box, Grid, Modal, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { toast } from "react-toastify";
import { serviceProvider } from "../../provider/serviceProvider";
import UserContext, { initAuthenticationTrue } from "../../context/UserContext";
import ButtonComponent from "../common/ButtonComponent";
import StyledTextfield from "../UI/InputComponent/StyledTextfield";

const useStyles = makeStyles({
  heading: {
    color: "#4A4A4A",
    fontFamily: "Roboto, sans-serif",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "400",
  },
  text: {
    color: "#808080",
    fontFamily: "Roboto, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
  },
});

const VerifyOtp = ({
  VerifyOtpModal,
  handleCloseVerifyOtpModal,
  handleCloseModal,
  mobileNumber,
  returnUrl = '/'
}: any) => {
  const [otp, setOtp] = React.useState("");
  const [loader, setLoader] = useState(false);
  const context = useContext(UserContext);

  const handleResendOtp = (mobileNo: string) => {
    serviceProvider.userService
      .requestOtp(mobileNo)
      .then((res: any) => {
        toast.success(res.message);
      })
      .catch((err) => {
        toast.error(err.data?.message || "Something Went Wrong!");
      });
  };

const handleVerifyOtp = () => {
  setLoader(true);
  const payload = {mobileNumber,otp}
  serviceProvider.authenticationService.login(payload).then((x:any) => {
    context.setAuthentication(initAuthenticationTrue);
      console.log({x});
      if (x) {
        handleCloseVerifyOtpModal();
        console.log({x})
        if (x?.session?.role[0]?.authority &&
          ["ROLE_ADMIN:EDIT", "ROLE_ADMIN:VIEW", "ROLE_OPERATOR:EDIT", "ROLE_OPERATOR:VIEW","ROLE_BLOGGER:EDIT","ROLE_BLOGGER:VIEW"].includes(x.session.role[0].authority)) {
          toast.success("User Verified.");
          window.location.href = returnUrl;
      } else {
          toast.error("You are not authorized.");
      }

      }else{
        toast.error(x?.message ||"Something Went Wrong.")
      }
      setLoader(false);
    
  }).catch(err => {
    console.log(err)
    setLoader(false);
    toast.error(err?.error?.data?.message || "Something Went Wrong!")
  });
};

  const classes = useStyles();

  function showLastThreeDigits(mobileNumber: string) {
    if (mobileNumber.length === 10) {
      const lastThreeDigits = mobileNumber.substring(mobileNumber.length - 3);
      const hiddenPart = "x".repeat(mobileNumber.length - 3);
      const maskedNumber = hiddenPart + lastThreeDigits;
      return maskedNumber;
    }
  }

  const handleChange = (e: any) => {
    setOtp(e.target.value);
  };

  return (
    <>
      <Modal
        open={VerifyOtpModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-container verify-otp-modal" onKeyDown={(e) => {
    if (e.key === "Enter" && otp.length === 6 && !loader) {
      handleVerifyOtp();
    }
  }}>
          <Grid item xs={12}></Grid>
          <Grid item xs={12} className="verify-otp-container">
            <Grid container maxWidth="265px">
              <Grid item xs={12}>
                <Grid container rowSpacing={1}>
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      component="h6"
                      textAlign="center"
                      className="heading"
                    >
                      Enter OTP
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      component="p"
                      textAlign="center"
                      className="sub-heading"
                    >
                      An OTP has been sent to{" "}
                      {showLastThreeDigits(mobileNumber)}
                    </Typography>
                  </Grid>
                  <Grid container item xs={12} justifyContent="center">
                    {/* <OTPInput
                    autoFocus
                    length={6}
                    className="otpContainer"
                    inputClassName="otpInput"
                    onChangeOTP={handleChange}
                  /> */}

                    <StyledTextfield
                      fullWidth
                      value={otp}
                      onChange={handleChange}
                      onKeyDown={(e) => {
    if (e.key === "Enter" && otp.length === 6 && !loader) {
      handleVerifyOtp();
    }
  }}
                      // className="signup-input"
                      type="text" // changed here
                      variant="standard"
                      inputProps={{
                        maxLength: 6,
                        inputMode: "numeric", // mobile numeric keyboard
                        pattern: "[0-9]*", // optional: numeric input
                      }}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          px: "10px",
                          border: "1px solid rgba(47, 66, 111, 0.30) !important",
                          borderRadius: "20px !important",
                          "& .MuiInputBase-input": {
                            textAlign: { xs: "center", sm: "left" }, // Center placeholder text for xs
                          },
                        },
                      }}
                      placeholder=""
                      sx={{ mt: 1.25 }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      component="span"
                      textAlign="center"
                      className="sub-heading resend-otp"
                      onClick={() => handleResendOtp(mobileNumber)}
                    >
                      Resend OTP
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <ButtonComponent
                      loader={loader}
                      disabled={loader || otp.length <= 5}
                      onClick={handleVerifyOtp}
                      label="Verify"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};
export default VerifyOtp;
